(function () {
  'use strict';

  function stopEvent() {
      return {
          restrict: 'A',
          link: function (scope, element, attr) {
            element.on(attr.stopEvent, function (e) {
              e.stopPropagation();
            });
          }
      }
  }

  stopEvent.$inject = [];

  angular.module('ecap.common').directive('stopEvent', stopEvent);
})();